export const teamPermissions = {
  pageId: 6,
  name: 'User/Team Management',
  path: 'teams',
  sections: {
    1: {
      name: 'Change Package',
      sectionId: 11,
      path: 'change-package',
    },
    2: {
      name: 'Login as User',
      sectionId: 12,
      path: 'login-as-user',
    },
    3: {
      name: 'SSO Admin',
      sectionId: 13,
      path: 'sso-admin',
    },
    4: {
      name: 'Purge User Data',
      sectionId: 15,
      path: 'purge-user-data',
    },
    5: {
      name: 'Edit Users/Teams',
      sectionId: 17,
      path: 'edit-users-teams',
    },
    6: {
      name: 'Privileged Management',
      sectionId: 19,
      path: 'privileged-management',
    },
  },
} as const;
